<svelte:options tag={null} />

<script lang="ts">
  import { afterUpdate } from 'svelte/internal';
  import { EventHandler } from '../../utilities/EventHandler';
  export let title: string;
  export let modaltitle: string;
  export let isopen: boolean;
  export let closebuttontext = 'Close';
  $: isopen
    ? eventHandler.dispatch('modal-opened', {})
    : eventHandler.dispatch('modal-closed', {});
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  let scrollable: boolean;

  let root: HTMLElement;
  let eventHandler = new EventHandler();

  afterUpdate(() => {
    const modal = root.querySelector('.mc-modal');
    const body = root.querySelector('.mc-modal__body');
    const content = root.querySelector('.mc-modal__content');

    const bodyHeight = body ? body.clientHeight : 0;
    const contentHeight = content ? content.scrollHeight : 0;

    if (contentHeight > bodyHeight && modal) {
      modal.classList.add('mc-modal--overflow');
    }
  });

  function onClose(): void {
    isopen = false;
  }
</script>

<div bind:this={root}>
  <div
    class="mc-modal {scrollable ? ' mc-modal--overflow' : ''}"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalTitle"
    aria-hidden={!isopen}
    {...attributes}
  >
    <div class="mc-modal__dialog {isopen ? ' is-open' : ''}" role="document">
      <header class="mc-modal__header">
        <h2 class="mc-modal__title" id="modalTitle">{modaltitle}</h2>
        <button
          class="mc-modal__close"
          type="button"
          on:click={() => onClose()}
        >
          <span class="mc-modal__close-text">{closebuttontext}</span>
        </button>
      </header>
      <main class="mc-modal__body">
        <article class="mc-modal__content">
          {#if title}
            <h3 class="mc-modal__heading" id="layerTitle">{title}</h3>
          {/if}
          <slot name="content" />
        </article>
      </main>
      <footer class="mc-modal__footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
  <div
    class="mc-modal-overlay {isopen ? ' is-visible' : ''}"
    tabindex="-1"
    role="dialog"
  />
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/c.modal';
</style>
